module.exports = __webpack_public_path__ + "img/b3.cb048b47.jpg";